import React from "react";
import ReactDOM from "react-dom/client";
import "./utils/i18n"; // i18n yapılandırmasını yükle
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance ölçümü
reportWebVitals();
